//import Swal from "sweetalert2"
import 'sweetalert2/dist/sweetalert2.min.css'
export default{
    namespaced:true,

    state:{
        servicios:[],
        areas:[],
        tipoAlta:[],

        especialidades:[],

        derechohabiencia:[
            {value:1, text:'IMMS'},
            {value:2, text:'ISSSTE'},
            {value:3, text:'PEMEX'},
            {value:4, text:'SEDENA'},
            {value:5, text:'SEMAR'},
            {value:6, text:'Gobierno estatal'},
            {value:7, text:'Seguro privado'},
            {value:8, text:'Seguro popular'},
            {value:9, text:'IMSS bienestar'},
            {value:10, text:'Seguro gratitud'},
            {value:11, text:'Ninguno'},
            {value:12, text:'Se ignora'},
            {value:13, text:'ISSFAM'},
            {value:14, text:'INSABI'},
        ],

        tiposReferencias:[
            {value:1, text:'Espacio físico'},
            {value:2, text:'Consulta'},
            {value:99, text:'Otro'},
        ],
        estadosReferencias:[
            {value:1, text:'Solicitado', color:'blue'},
            {value:2, text:'En revisión', color:'orange'},
            {value:3, text:'Aceptado', color:'green'},
            //{value:4, text:'Referido/Contra referido', color:'purple'},
            {value:98, text:'No aceptado', color:'red'},
            {value:99, text:'Cancelado', color:'grey'},
        ],
        
    },

    mutations:{
        
    },

    actions:{
        

        // Para el select de servicio
        async cargaArea(context){
            let sr = await this.$http({
                url:'/catalogos/areas',
                method:'GET',
            })
            context.state.areas = sr.data
        },

        // Para el select de servicio
        async cargaServicio(context){
            let sr = await this.$http({
                url:'/catalogos/servicios',
                method:'GET',
            })
            context.state.servicios = sr.data
        },
        
        // Para el select de servicio
        async cargaEspecialidad(context){
            let sr = await this.$http({
                url:'/catalogos/especialidadesListTodas',
                method:'GET',
            })
            context.state.especialidades = sr.data
        },

        // Para el select de los tipos de alta
        async tipoAlta(context){
            let sr = await this.$http({
                url:'/catalogos/tiposaltas',
                method:'GET',
            })
            context.state.tipoAlta = sr.data
        },

        // Para el select de las instituciones de derechohabiencia
        async insDerechohabiencia(context){
            let sr = await this.$http({
                url:'/catalogos/instDerechohabiencia',
                method:'GET',
            })
            context.state.derechohabiencia = sr.data
        },
    },
}